<div
  class="toast-container"
  [class.success]="toast?.type === types.success"
  [class.error]="toast?.type === types.error"
>
  <ion-icon
    name="alert-circle-outline"
    data-cy="toast-container-icon"
  ></ion-icon>
  <span class="message" data-cy="toast-messsage-text">
    {{ toast?.message | translate }}
  </span>

  <ion-icon
    *ngIf="canDismiss"
    name="close-circle"
    class="btn-dismiss"
    data-cy="dismiss-button-icon"
    (click)="dismiss()"
  ></ion-icon>
</div>
